import { Injectable, inject } from '@angular/core';
import { Auth, GoogleAuthProvider, signInWithPopup, signOut } from '@angular/fire/auth';

import { loginErrors } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private auth: Auth = inject(Auth);
  private provider = new GoogleAuthProvider();
  async logOut() {
    return signOut(this.auth);
  }

  async logIn(emailAddress?: string) {
    if (emailAddress != null) {
      this.provider.setCustomParameters({
        hd: emailAddress,
      });
    }
    const response = await signInWithPopup(this.auth, this.provider);
    const emailDomain = response.user.email;
    if (emailAddress && emailDomain && !this.isValidDomain(emailDomain, emailAddress)) {
      await response.user.delete();
      this.logOut();
      throw new Error(loginErrors.INVALID_DOMAIN);
    }
    return response;
  }

  isValidDomain(email: string, emailAddress: string) {
    const regect = /(?<=@)[^\s]+/;
    const result = email?.match(regect);
    const domain = result ? result[0] : null;
    if (domain != emailAddress) {
      return false;
    }
    return true;
  }
}
